import { Suspense } from 'react';
import { createBrowserRouter, RouterProvider as RouterProviderLib } from 'react-router-dom';
import { MainPage } from '@/pages/MainPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { MainLayout } from '@/app/layouts/MainLayout';
import { useTheme } from '@/app/providers/ThemeProviders';
import AuthPage from '@/pages/AuthPage/ui/AuthPage';
import SucсessPage from '@/pages/AcquiringPage/ui/Sucсess/SucсessPage';
import FailPage from '@/pages/AcquiringPage/ui/Fail/FailPage';
import { PageLoader } from '@/shared/ui/PageLoader';

export const router = createBrowserRouter(
    [
        {
            path: '/',
            element: <MainLayout />,
            children: [{ index: true, element: <MainPage /> }],
        },
        { path: '/auth', element: <AuthPage /> },
        { path: '/acquiring/success', element: <SucсessPage /> },
        { path: '/acquiring/fail', element: <FailPage /> },
        { path: '*', element: <NotFoundPage /> },
    ],
    { basename: '/ipoteka' }
);

const RouterProvider = () => {
    const { theme } = useTheme();
    document.body.className = theme;

    return (
        <Suspense fallback={<PageLoader />}>
            <RouterProviderLib router={router} />
        </Suspense>
    );
};

export default RouterProvider;
